import React from 'react';

import { Trans, useTranslation } from 'react-i18next';
import Event from '../../../../models/eventModel';
import useAppContext from '../../../../context/useAppContext';

import { EventSelector } from '../event-selector/event-selector';
import { Form, Input } from 'semantic-ui-react';

export function DefaultWidgetTemplate({ form, onChange }) {
    const { t } = useTranslation();
    const [{ organization }] = useAppContext();
    const [selectedEvent, setSelectedEvent] = React.useState(null);

    const defaultQueryParams = {
        publication_status__in: 'draft,published'
    };

    const [events, loadingEvents] = Event.useApiModel(
        {
            organizationId: organization.id,
            query: defaultQueryParams
        },
        [organization]
    );

    const _onChange = React.useCallback(
        event => {
            setSelectedEvent(event);
            onChange('widget_key', `E${event}`);
            onChange('widget_config', {
                event_id: event
            });
        },
        [onChange]
    );

    return (
        <div>
            <EventSelector events={events} loadingEvents={loadingEvents} event={selectedEvent} onChange={_onChange} />
            <Form.Field required>
                <label>{t(`ticket.widget.formStep.widget_key`)}</label>
                <Input disabled label={`https://widget.weezevent.com/ticket/`} value={form.widget_key} />
            </Form.Field>
        </div>
    );
}

export function RefundWidgetTemplate({ form, formErrors, onChange }) {
    const { t } = useTranslation();

    return (
        <Form.Field required error={formErrors['widget_key'] ? true : false}>
            <label>{t(`ticket.widget.formStep.widget_key`)}</label>
            <Input label={`https://widget.weezevent.com/ticket/`} value={form.widget_key} onChange={synth => onChange('widget_key', synth.target.value)} />
            {formErrors['widget_key'] ? (
                <label>
                    <Trans i18nKey={formErrors['widget_key']}>This field is required</Trans>{' '}
                </label>
            ) : null}
        </Form.Field>
    );
}

export default {
    basic: DefaultWidgetTemplate,
    refund: RefundWidgetTemplate,
    manage_order: RefundWidgetTemplate,
    manage_order_all_included: RefundWidgetTemplate
};
